import {View} from 'react-native';
import Text from '@/components/basic/text';
import React from 'react';
import {INDEX_TO_O, RESULT_INDEX} from '../constant';
import DigitBall from '../component/digit-ball';
import theme from '@/style';
import dayjs from 'dayjs';

export interface HistoryItemProps {
  index?: number;
  drawTime: number;
  roundNo?: string;
  results?: string[];
}

const HistoryItem = ({
  index = 0,
  roundNo = 'No.777',
  results = ['998866', '556677'],
  drawTime,
}: HistoryItemProps) => {
  const backgroundColor = React.useMemo(() => {
    if (index % 2 === 0) {
      return theme.basicColor.white;
    } else {
      return '#F8F9FF';
    }
  }, [index]);
  const getBallStyle = React.useCallback(
    (ballType: string, disabled: boolean): React.CSSProperties => ({
      ...stylesWeb.ball,
      backgroundColor: disabled
        ? '#D9D9D9'
        : ballType === 'A'
        ? '#D57300'
        : ballType === 'B'
        ? '#0087D4'
        : ballType === 'C'
        ? '#D50000'
        : '#67A519',
      opacity: disabled ? 0.3 : 1,
    }),
    [],
  );

  if (typeof document !== 'undefined') {
    return (
      <div
        style={{
          ...stylesWeb.wrap,
          backgroundColor,
        }}>
        <div style={stylesWeb.left}>
          <div style={stylesWeb.roundNo}>{roundNo}</div>
          {typeof drawTime === 'string' ? null : (
            <div>
              <div style={stylesWeb.timeText}>
                {dayjs(drawTime * 1000).format('DD-MM-YYYY')}
              </div>
              <div style={stylesWeb.timeText}>
                {dayjs(drawTime * 1000).format('hh:mm A')}
              </div>
            </div>
          )}
        </div>
        <div style={stylesWeb.right}>
          {results.map((item, _i) => (
            <div style={stylesWeb.resultRow} key={_i}>
              <div style={stylesWeb.resultTitle}>
                {INDEX_TO_O[_i + 1]} Prize：
              </div>
              <div style={stylesWeb.ballList}>
                {item
                  .split('')
                  .slice(0, 6)
                  .map((pie, _ii) => {
                    const ballType = RESULT_INDEX.slice(
                      -item.split('').slice(0, 6).length,
                    )[_ii];
                    const disabled = ballType === 'UNUSED';
                    return (
                      <div key={_ii} style={getBallStyle(ballType, disabled)}>
                        {pie}
                      </div>
                    );
                  })}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <View
      style={[
        theme.flex.row,
        theme.flex.centerByCol,
        theme.flex.between,
        theme.padding.l,
        {backgroundColor},
      ]}>
      <View style={[theme.flex.flex1, theme.margin.rightl]}>
        <Text size="medium" fontWeight="500" color={theme.basicColor.dark}>
          {roundNo}
        </Text>
        {typeof drawTime === 'string' ? null : (
          <View>
            <Text fontWeight="500">
              {dayjs(drawTime * 1000).format('DD-MM-YYYY')}
            </Text>
            <Text fontWeight="500">
              {dayjs(drawTime * 1000).format('hh:mm A')}
            </Text>
          </View>
        )}
      </View>
      <View style={{gap: theme.paddingSize.xxs}}>
        {results.map((item, _i) => (
          <View style={[theme.flex.row, theme.flex.between]} key={_i}>
            <Text fontFamily="fontInterBold">{INDEX_TO_O[_i + 1]} Prize：</Text>
            <View
              style={[
                theme.flex.row,
                {gap: theme.paddingSize.xxs},
                theme.margin.leftxxs,
              ]}>
              {item
                .split('')
                .slice(0, 6)
                .map((pie, _ii) => (
                  <DigitBall
                    disabled={
                      RESULT_INDEX.slice(-item.split('').slice(0, 6).length)[
                        _ii
                      ] === 'UNUSED'
                    }
                    key={_ii}
                    digit={pie}
                    type={
                      RESULT_INDEX.slice(-item.split('').slice(0, 6).length)[
                        _ii
                      ]
                    }
                  />
                ))}
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};

export default HistoryItem;

const stylesWeb: Record<string, React.CSSProperties> = {
  wrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.75rem',
  },
  left: {
    flex: 1,
    marginRight: '1rem',
  },
  roundNo: {
    fontSize: '1rem',
    lineHeight: '1.5rem',
    fontWeight: 500,
    color: theme.basicColor.dark,
  },
  timeText: {
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    fontWeight: 500,
    color: '#31373D',
  },
  right: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
  },
  resultRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  resultTitle: {
    fontFamily: 'Inter-Bold',
    fontWeight: 700,
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    color: '#31373D',
  },
  ballList: {
    display: 'flex',
    gap: '0.125rem',
    marginLeft: '0.25rem',
  },
  ball: {
    width: '1.25rem',
    height: '1.25rem',
    borderRadius: '9999px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: '0.75rem',
    lineHeight: '1rem',
    fontWeight: 700,
  },
};
